export enum SCREEN_SIZE {
	SM = '640px',
	MD = '768px',
	LG = '1024px',
	XL = '1280px',
}

